























































import Vue from 'vue';
import moment from 'moment';
import CustomerInfoField from './CustomerInfoField.vue';
import CustomerInfoFieldEdit from './CustomerInfoFieldEdit.vue';
import AddRemarkBox from './AddRemarkBox.vue';
import RemarkItem from './RemarkItem.vue';
import CustomerVuex from '../../../vuex/common';
import Customer from '../../../models/Customer';
import CustomerProp, { PropType } from '../../../models/CustomerProp';
import CustomerGroup from '../../../models/CustomerGroup';
import customerClient from '../../../apis';

const deleteVisible: any[] = [];

export default Vue.extend({
  mixins: [CustomerVuex],
  components: {
    AddRemarkBox,
    CustomerInfoField,
    CustomerInfoFieldEdit,
    RemarkItem,
  },
  data() {
    return {
      deleteVisible,
      whiteFieldsList: [
        'phone',
        'realName',
        'sex',
        'birth',
        'citizenId',
        'email',
        'address',
        'edu',
        'wechat',
        'area',
        'maritalStatus',
        'career',
        'industry',
        'income',
        'hobby',
        'telephone',
        'qq',
      ],
    };
  },
  props: {
    traceTotal: {
      type: Number,
      default: null,
    },
  },
  computed: {
    customer(): Customer | undefined {
      return this.customerState.currentCustomer;
    },
    subscribeTime(): string {
      const timestamp = this.customerState.currentCustomer!.wxProps.subscribeTime;
      const time = moment(timestamp).format('YYYY年MM月DD日 HH:mm:ss');
      const diff = moment(timestamp).fromNow();
      return `${time}（${diff}）`;
    },
    editableFields(): CustomerProp[] {
      return this.customerState.props.filter((prop: CustomerProp) => {
        return !prop.builtIn || this.whiteFieldsList.includes(prop.fieldName);
      });
    },
    displayGroups(): string {
      const groupIds = this.customer.groups;
      return this.customerState.customerGroups.filter((group: CustomerGroup) => {
        return groupIds.includes(group.id);
      }).map((group: CustomerGroup) => group.name).join(',');
    },
  },
  methods: {
    setDeleteVisible() {
      this.deleteVisible = Array(this.customer!.remarks.length).fill(false);
    },
  },
  mounted() {
    this.setDeleteVisible();
  },
});
